module.exports = __webpack_public_path__ + "static/media/filename (9).656a7d4c.png";